import { Box, Header, Text, makeUclComponent } from '@rbilabs/universal-components';

import Button, { ActionButtonVariants } from 'components/action-button';
import { getDesignToken, primitive, spacing } from 'styles/constants';
export const OrderIssuesContainer = Box.withConfig({
  background: getDesignToken('background-card'),
  minHeight: '$6',
  justifyContent: 'space-between',
  alignItems: 'center',
  shadow: {
    base: 'none',
    md: '1',
  },
  borderRadius: primitive.$borderRadius,
  marginTop: '$4',
  flexDirection: {
    base: 'column',
    md: 'row',
  },
  focusable: true,
  width: 'full',
  overflow: 'hidden',
});

export const HeaderContainer = Box.withConfig({
  width: 'full',
  paddingY: spacing.$4_5,
  paddingX: '$4',
  alignItems: 'flex-start',
  backgroundColor: primitive.$blackOpacity4,
  borderBottomWidth: 1,
  borderBottomColor: primitive.$blackOpacity10,
});

export const OrderIssuesDetails = Box.withConfig({
  flex: {
    md: 2,
  },
  paddingY: {
    base: '$4',
    md: '$6',
  },
  paddingX: {
    base: '$4',
    md: '$6',
  },
  width: 'full',
});

export const OrderIssuesHeading = Header.withConfig({
  textAlign: {
    base: 'center',
    md: 'left',
  },
  marginBottom: '$0',
  variant: 'headerThree',
  fontSize: 'lg',
});

export const OrderIssuesText = Text.withConfig({
  variant: 'bodyOne',
  marginBottom: {
    base: '$4',
    md: '$0',
  },
  marginTop: {
    md: '$2',
  },
});

export const StyledButtonContainer = Box.withConfig({
  padding: '$6',
});

export const StyledButton = makeUclComponent(Button).withConfig({
  color: primitive.$fieryRed,
  fontSize: 'md',
  variant: ActionButtonVariants.OUTLINE,
  _hover: {
    color: primitive.$fieryRedHover,
  },
});
